import React from "react";

import WheelSlices from "./WheelSlices";
import Spinner from "./Spinner";
import CentralLogo from "./CentralLogo";

import { GameTypeEnum } from "../../../enums";

import { useAppSelector } from "../../../store/hooks";

const Wheel: React.FC = () => {
  const winningNumber = useAppSelector((state) => state.wheel.winningNumber);
  const gameType = useAppSelector((state) => state.config.gameType);

  return (
    <div className="wheel_box">
      <div className="wheel_box1">
        <WheelSlices winningNumber={winningNumber} />
        <div className="white_border" />
        {gameType === GameTypeEnum.ONLINE ? <Spinner /> : <CentralLogo />}
      </div>
    </div>
  );
};
export default Wheel;
